@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/spacing";

web-vehicle-funnel-entrance {
    h1 {
        margin-bottom: spacing.$xl;
    }

    form {
        display: flex;
        gap: spacing.$lg;
        flex-direction: column;

        @media (min-width: breakpoints.$screen-sm-min) {
            flex-direction: row;
        }
    }

    fieldset {
        appearance: none;
        border: 0;
        padding: 0;
        margin: 0;
    }

    &.compact {
        form {
            flex-direction: row;

            input[type="text"] {
                width: 100%;
                min-width: 140px;
            }
        }
    }

    web-license-plate,
    web-button {
        display: block;
        margin-bottom: spacing.$md;
    }

    web-button button {
        width: 100%;
    }

    web-button + p {
        text-align: center;
    }
}
